import { render, staticRenderFns } from "./TheOrderAddPosition.vue?vue&type=template&id=50b11bc8&"
import script from "./TheOrderAddPosition.vue?vue&type=script&lang=js&"
export * from "./TheOrderAddPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports